export default {
  'common.captcha':'captcha',
  'common.second':'second',
  'common.systemtitle':'Renjian Logistics Management System',
  //操作

  'common.field.sequence': 'Sequence',
  'common.field.operation': 'Operation',

  'common.button.search':'Search',
  'common.button.reset':'Reset',
  'common.button.collapse':'Collapse',
  'common.button.OK':'OK',
  'common.button.cancel':'Cancel',
  'common.button.done':'Done',
  'common.button.browse':'Browse',
  'common.button.view':'View',
  'common.button.modify':'Modify',
  'common.button.delete':'Delete',
  "common.button.batchDelete":"BatchDelete",
  'common.button.import':'Import',
  'common.button.more':'More',
  'common.button.export':'Export',
  'common.button.logShow':'Log show',
  'common.button.refresh':'Refresh',
  'common.button.save':'Save',
    'common.button.add':'Add',
  "common.button.detail":"Detail",
  "common.button.journl":"Journl",

  "common.button.enable":"enable",
  "common.button.disconnected":"disconnected",

  'common.message.Tip':'Tip',
  'common.message.error':'Error',
  'common.message.warm_hint':'Warm hint',
  'common.message.delete.confirm': 'Are you sure to delete？',
  'common.message.operate.success': 'Operation succeeded!',
  'common.message.operate.failed': 'Operation failed!',
  'common.message.unknown.error':'Unknown error，please contact the administrator',
  "common.message.choose.exportColum":'Select the export column',
  "common.message.choose.please":"Please choose",
  "common.message.request.fail":"Request failed",
  //tips

  'error':'Error',
  'success':'Success',
  'common.message.delete.success':'Delete success',
  'common.message.delete.failed':'Delete failed',

  'common.title.SerialNumber': 'SerialNumber',
  'common.title.Operation': 'Operation',
  'common.title.memo': 'memo',

};
